export const config = {
  propsName: 'renderProps',
  name: 'SpHotZoneImg',
  type: 'activeTmpsConfig',
  icon: 'el-icon-picture',
  cnName: '热区图',
  tooltip: '热区图',
  base: {
    margin: [0, 0, 0, 0],
    
  },
  props: [
    {
      // tooltip:'背景图的tooltip',
      type: 'sp-hotZoneImgCmp',
      key: 'hotZoneImg',
      bind: {
        label: '热区图'
      },
      on: {},
      value: {
        config: {
          imgUrl: ''
        },
        data: []
      }
    },
    {
      // tooltip:'背景图的tooltip',
      type: () => import('@/weappTmps/comps/backgroundColor/index.vue'),
      cmpPath: '/comps/backgroundColor/index.vue',
      key: 'backgroundColor',
      bind: {
        label: '背景色'
      },
      on: {},
      value: null
    },
    {
      type: () => import('@/weappTmps/comps/margin/index.vue'),
      cmpPath: '/comps/margin/index.vue',
      key: 'margin',
      bind: {
        label: '边距'
      },
      on: {},
      value: null
    }
  ]
}
